export interface IKeyValueMapperModel {
  key: string;
  value: string;
}

export class KeyValueMapperModel implements IKeyValueMapperModel {
  constructor(
    public key: string,
    public value: string,
  ) {}
}
